module.exports = new __parcel__URL__("ocean-production--dataset-cover.24060eab.jpg").toString();